// extracted by mini-css-extract-plugin
export var fadeIn = "_ij-1";
export var modalContent = "_ij-3";
export var overlay = "_ij-0";
export var popoverContent = "_ij-2";
export var results = "_ij-5";
export var searchInputWrapper = "_ij-4";